import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";

import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

// const { SearchBar } = Search;

import { Row, Col, Modal } from "react-bootstrap";

import FarmerMasterService from "../../services/farmermaster.service";
import authService from "../../services/auth.service";
import TimeregService from "../../services/timereg.service";

import ModaladdFarmermaster from "./ModaladdFarmermaster";
import ModalAddDetail from "./ModalAddDetail";
import ModalEditDetail from "./ModalEditDetail";
import FormUpload from "./FormUpload";
import ModalViewMasterapprove from "../ApproveRegister/ModalViewMasterapprove";

import { PDFDownloadLink } from "@react-pdf/renderer";
import FarmerMasterDocumenttemp from "../../views/PrintPdf/FarmerMasterDocumenttemp";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";

moment.locale("th");

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";

import "./Farmermaster.css";

//import downloadPDF
import DownloadPDF from "./DownloadPdf";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const renderTooltipUpload = (props) => (
  <Tooltip {...props}>อัพโหลดไฟล์เพิ่มเติม</Tooltip>
);
const renderTooltipEdit = (props) => (
  <Tooltip {...props}>แก้ไขข้อมูลการจดทะเบียน</Tooltip>
);
const renderTooltipDelete = (props) => (
  <Tooltip {...props}>ลบการจดทะเบียน</Tooltip>
);
const renderTooltipPrint = (props) => (
  <Tooltip {...props}>พิมพ์บัตรชั่วคราว</Tooltip>
);

function Farmermasterlist() {
  const [loadingPage, setLoadingPage] = useState(true);
  const [loadAlert, setLoadAlert] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [show_add, setShow_add] = useState(false);
  const [show_detail, setShow_detail] = useState(false);
  const [show_editdetail, setShow_editdetail] = useState(false);
  const [btnAdd, setBtnAdd] = useState(false);
  const [timereg_id, setTimereg_id] = useState(null);
  const [master_select, setMaster_select] = useState({});
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [select_Master_id, setSelect_Master_id] = useState(0);
  const [currentTimeReg, setCurrentTimeReg] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [printSelect, setPrintSelect] = useState({});
  const [current_timereg_id, setCurrent_timereg_id] = useState(0);
  const [showViewApprove, setShowViewApprove] = useState(false);
  const [master_selectView, setMaster_selectView] = useState({});

  const user = authService.getCurrentUser();

  const [isDisabled, setIsDisabled] = useState(false);
  const daystop = 10;

  useEffect(() => {
    TimeregService.getLastCurrent().then((res) => {
      const stop = res.data?.data?.timereg_stop;
      if (!stop) {
        setIsDisabled(true); // ถ้าไม่มีข้อมูล ปิดปุ่มเลย
        return;
      }

      const stopDate = new Date(stop);
      const expireDate = new Date(stopDate);
      expireDate.setDate(stopDate.getDate() + daystop);

      const now = new Date();
      setIsDisabled(now > expireDate);
    });
  }, []);

  const submitEditDetail = (dataform) => {
    const form = {
      timereg_id: timereg_id,
      user_id: user.user.user_id,
      region_id: user.user.user_reg,
      masterid: master_select.masterid,
      ...dataform,
    };
    // alert(JSON.stringify(form));
    setLoadAlert(true);
    FarmerMasterService.EditregisterFarmerMaster(form)
      .then((response) => {
        if (response.data.success) {
          setData((obj) => [
            ...obj.map((item) => {
              if (item.masterid != response.data.data.masterid) {
                return item;
              } else {
                return response.data.data;
              }
            }),
          ]);
          // setData([response.data.data, ...data]);
          setShow_editdetail(false);
        }
      })
      .catch((error) => {
        console.error("error create data: ", error);
      })
      .finally(() => {
        setLoadAlert(false);
      });
  };

  const submitAddDetail = (dataform) => {
    const form = {
      timereg_id: timereg_id,
      user_id: user.user.user_id,
      region_id: user.user.user_reg,
      ...dataform,
    };
    setLoadAlert(true);
    FarmerMasterService.registerFarmerMaster(form)
      .then((response) => {
        // alert(response.data.data.masterid);
        if (response.data.success) {
          setData([response.data.data, ...data]);
          setShow_detail(false);
          setShowUploadForm(true);
          setSelect_Master_id(response.data.data.masterid);
          toast.success("บันทึกข้อมูลเรียบร้อย");
        }
      })
      .catch((error) => {
        console.error("error create data: ", error);
      })
      .finally(() => {
        setLoadAlert(false);
      });
  };
  useEffect(() => {
    checkTimereg();
  }, []);

  const clikcAddMaster = (masteridcard, regsugar_id) => {
    setShow_add(false);
    setMaster_select({ masteridcard: masteridcard, regsugar_id: regsugar_id });
    setShow_detail(true);
  };
  const clickUpload = (row) => {
    setSelect_Master_id(row.masterid);
    setShowUploadForm(true);
  };

  const checkTimereg = () => {
    TimeregService.getLastCurrent()
      .then((response) => {
        if (response.data.success && response.data.data) {
          setCurrentTimeReg(response.data.data);
          setTimereg_id(response.data.data.timereg_id);
          getData(user.user.user_reg, response.data.data.timereg_id);
        } else {
          setCurrentTimeReg({ message: "ยังไม่มีรอบจดทะเบียน" });
        }
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
      })
      .finally(() => setLoadingPage(false));
    TimeregService.getCurrent()
      .then((response) => {
        if (response.data.success && response.data.data) {
          setCurrent_timereg_id(response.data.data.timereg_id);
          setBtnAdd(false);
        } else {
          setCurrent_timereg_id(0);
          setBtnAdd(true);
        }
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
      })
      .finally(() => setLoadingPage(false));
  };

  const getData = (reg_id, timereg_id) => {
    FarmerMasterService.getFarmerMaster(reg_id, timereg_id)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoadingPage(false);
      });
  };
  const clickEdit = (row) => {
    // alert(JSON.stringify(row));
    setMaster_select(row);
    setShow_editdetail(true);
  };
  const clickDelete = (row) => {
    if (window.confirm("ต้องการลบ")) {
      FarmerMasterService.deleteFarmerMaster({ farmer_master_id: row.masterid })
        .then((response) => {
          if (response.data.success) {
            setData((a) => a.filter((b) => b.masterid != row.masterid));
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          console.error("error delete", error);
        });
    }
  };
  const clickPrintPDF = (row) => {
    setShowAlert(true);
    setPrintSelect(row.row);
  };
  const PrintPDF = (props) => {
    const handleClose = () => props.set_show(false);
    return (
      <>
        <Modal show={props.show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>PrintPdf</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PDFDownloadLink
              document={
                <FarmerMasterDocumenttemp master_id={props.row.masterid} />
              }
              fileName={
                "บัตรหัวหน้ากลุ่มชั่วคราว-" + props.row.mastername + ".pdf"
              }
            >
              {({ blob, url, loading, error }) => {
                console.log(blob, url, error);
                return loading ? (
                  "..."
                ) : (
                  <i
                    className="fa fa-print custom-icon-table"
                    style={{ color: "green" }}
                  >
                    {" " + props.row.mastername}
                  </i>
                );
              }}
            </PDFDownloadLink>
          </Modal.Body>
        </Modal>
      </>
    );
  };
  PrintPDF.propTypes = {
    show: PropTypes.bool,
    set_show: PropTypes.func,
    row: PropTypes.object,
  };
  const clickViewApprove = (row) => {
    setMaster_selectView(row);
    setShowViewApprove(true);
  };

  const ActionsEdit = (row) => {
    if (
      row.row.approve_status == "อนุมัติ" ||
      row.row.approve_status == "ไม่อนุมัติ"
    ) {
      return (
        <>
          <i
            className="bi bi-search custom-icon-table"
            onClick={() => clickViewApprove(row.row)}
          ></i>
          {row.row.farmer_card != "-" ? (
            <DownloadPDF
              card={row.row.farmer_card}
              idno={row.row.masteridcard}
            />
          ) : (
            ""
          )}
        </>
      );
    } else {
      return (
        <>
          <div hidden={isDisabled}>
            <OverlayTrigger placement="top" overlay={renderTooltipEdit}>
              <i
                className="bi bi-pencil custom-icon-table"
                onClick={() => clickEdit(row.row)}
              ></i>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={renderTooltipUpload}>
              <i
                className="bi bi-upload custom-icon-table"
                style={{ color: "green" }}
                onClick={() => clickUpload(row.row)}
              ></i>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={renderTooltipDelete}>
              <i
                className="bi bi-trash custom-icon-table"
                style={{ color: "red" }}
                onClick={() => clickDelete(row.row)}
              ></i>
            </OverlayTrigger>
          </div>

          <OverlayTrigger placement="top" overlay={renderTooltipPrint}>
            <i
              className="fa fa-print custom-icon-table"
              style={{ color: "green" }}
              onClick={() => clickPrintPDF(row)}
            ></i>
          </OverlayTrigger>
        </>
      );
    }
  };

  const actionsEdittFormatter = (cell, row) => {
    return <ActionsEdit row={row} />;
  };

  const columns = [
    {
      text: "masterId",
      dataField: "masterid",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "mastername",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "เลขบัตรประชาชน",
      dataField: "masteridcard",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สร้างโดย",
      dataField: "user_create",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ผลการพิจารณา",
      dataField: "approve_status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "5%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },

    {
      text: "อนุมัติโดย",
      dataField: "approve_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "8%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    // {
    //   text: "เลขชาวไร่",
    //   dataField: "farmer_card_id",
    //   sort: true,
    //   editable: false,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "10%" };
    //   },
    //   style: {
    //     // wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    //   filter: textFilter({ placeholder: "ค้นหา" }),
    // },
    // {
    //   text: "เลขหัวหน้ากลุ่ม",
    //   dataField: "farmer_card",
    //   sort: true,
    //   editable: false,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "10%" };
    //   },
    //   style: {
    //     // wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    //   filter: textFilter({ placeholder: "ค้นหา" }),
    // },
    {
      text: "เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "หมายเหตุ",
      dataField: "comments",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "5%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ดำเนินการ",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsEdittFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  const handleClickAdd = () => {
    setShow_add(true);
  };

  if (loadingPage) return <Spinner animation="border" variant="primary" />;
  if (error) return `Error :${error}`;

  return (
    <div>
      {loadAlert ? <LoadingAlert /> : ""}
      <PrintPDF row={printSelect} show={showAlert} set_show={setShowAlert} />
      <ModalViewMasterapprove
        show={showViewApprove}
        hidden={setShowViewApprove}
        master_select={master_selectView}
      />
      <FormUpload
        show={showUploadForm}
        hidden_func={setShowUploadForm}
        master_id={select_Master_id}
      />
      <ModalEditDetail
        show={show_editdetail}
        hidden={setShow_editdetail}
        master_select={master_select}
        afterSubmit={submitEditDetail}
        timereg_id={current_timereg_id}
      />
      <ModalAddDetail
        show={show_detail}
        hidden={setShow_detail}
        master_select={master_select}
        afterSubmit={submitAddDetail}
      />
      <ModaladdFarmermaster
        show={show_add}
        hidden={setShow_add}
        // data={data}
        // setdata={(a) => setData(a)}
        onClickAdd={clikcAddMaster}
        timereg_id={current_timereg_id}
      />
      <ToolkitProvider
        bootstrap4
        keyField="masterid"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <React.Fragment>
            <Row>
              <Col md={4}>
                <button
                  className={btnAdd ? "btn btn-warning" : "btn btn-primary"}
                  onClick={handleClickAdd}
                  style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
                  disabled={btnAdd}
                >
                  จดทะเบียนหัวหน้ากลุ่มชาวไร่อ้อย
                </button>
                {/* <SearchBar {...prop.searchProps} /> */}
              </Col>

              <Col md={8}>
                <div className={btnAdd ? "invalid-register" : "valid-register"}>
                  {btnAdd && !currentTimeReg.message ? (
                    <>
                      <span>สิ้นสุดการจดทะเบียน : </span>
                    </>
                  ) : (
                    ""
                  )}
                  {currentTimeReg.message ? (
                    <>
                      <span>{currentTimeReg.message}</span>
                    </>
                  ) : (
                    <>
                      {" "}
                      <span style={{ fontWeight: "bold" }}>
                        {currentTimeReg.timereg_desc}
                      </span>
                      <span>{" เริ่มวันที่ "}</span>
                      <span>
                        {moment(currentTimeReg.timereg_start)
                          .add(543, "year")
                          .locale("th")
                          .format("ll")}
                      </span>
                      <span>{" ถึงวันที่ "}</span>
                      <span>
                        {moment(currentTimeReg.timereg_stop)
                          .add(543, "year")
                          .locale("th")
                          .format("ll")}
                      </span>
                    </>
                  )}
                </div>
              </Col>
            </Row>
            <hr />
            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              //   cellEdit={cellEditFactory({
              //     mode: "click",
              //     blurToSave: true,
              //     afterSaveCell,
              //   })}
              filter={filterFactory()}
              // loading={true}
              {...prop.baseProps}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   afterSaveCell: handleChange,
              //   beforeSaveCell: beforeSaveCell,
              // })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default Farmermasterlist;
